import React, { useState, useEffect } from 'react';
import { randers3data } from '../../../../../Services/SystemSettings/SystemServices';

function Smtp() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const key = 'SMTP';
        const responseData = await randers3data(key);
        setData(responseData);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (key, value) => {
    setData(prevData => {
      const newData = prevData.map(item => {
        if (item.key === key) {
          return { ...item, value };
        }
        return item;
      });
      return newData;
    });
  };

  return (
    <div id="s3div">
      <form className="row g-3">
        <div className="col-12">
          <label htmlFor="host" className="form-label">Host</label>
          <input
            type="text"
            className="form-control"
            id="host"
            name='host'
            value={data?.find(item => item.key === 'host')?.value || ''}
            onChange={(e) => handleInputChange('host', e.target.value)}
          />
          <div className={`gst-err-host invalid-feedback`}>Please provide Host.</div>
        </div>
        <div className="col-12">
          <label htmlFor="username" className="form-label">User Name</label>
          <input
            type="text"
            className="form-control"
            id="username"
            name='username'
            value={data?.find(item => item.key === 'username')?.value || ''}
            onChange={(e) => handleInputChange('username', e.target.value)}
          />
          <div className={`gst-err-username invalid-feedback`}>Please provide User Name.</div>
        </div>
        <div className="col-12">
          <label htmlFor="password" className="form-label">Password</label>
          <input
            type="text"
            className="form-control"
            id="password"
            name='password'
            value={data?.find(item => item.key === 'password')?.value || ''}
            onChange={(e) => handleInputChange('password', e.target.value)}
          />
          <div className="d-flex"  >
            <input type="checkbox" id="showHidePassword" />
            <span >Show Password</span>
          </div>
          <div className="smtp-err-password invalid-feedback">Please provide password.</div>
          <div className="new-system-user-password-validate invalid-feedback">
            Password should be minimum 8 characters with Captial, small letter, a number and a special character.
          </div>
          <div className={`gst-err-password invalid-feedback`}>Please provide Password.</div>
        </div>
        <div className="col-12">
          <label htmlFor="port" className="form-label">Port</label>
          <input
            type="text"
            className="form-control"
            id="port"
            name='port'
            value={data?.find(item => item.key === 'port')?.value || ''}
            onChange={(e) => handleInputChange('port', e.target.value)}
          />
          <div className={`gst-err-port invalid-feedback`}>Please provide Port.</div>
        </div>
        <div className="col-12">
          <label htmlFor="sender_name" className="form-label">Sender Name</label>
          <input
            type="text"
            className="form-control"
            id="sender_name"
            name='sender_name'
            value={data?.find(item => item.key === 'sender_name')?.value || ''}
            onChange={(e) => handleInputChange('sender_name', e.target.value)}
          />
          <div className={`gst-err-sender_name invalid-feedback`}>Please provide Sender Name.</div>
        </div>
        <div className="col-12">
          <label htmlFor="sender_mail" className="form-label">Sender Mail</label>
          <input
            type="text"
            className="form-control"
            id="sender_mail"
            name='sender_mail'
            value={data?.find(item => item.key === 'sender_mail')?.value || ''}
            onChange={(e) => handleInputChange('sender_mail', e.target.value)}
          />
          <div className={`gst-err-sender_mail invalid-feedback`}>Please provide Sender Mail.</div>
        </div>
        <div className="text-center">
          <button type="Update" id="gstupdate" className="btn btn-primary">Update</button>
          <button type="Reset" className="btn btn-secondary">Reset</button>
        </div>
      </form>
    </div>
  );
}

export default Smtp;